import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ViewEmailsComponent } from './view-emails.component';
import { MaterialModule } from 'src/app/shared/material/material.module';



@NgModule({
  declarations: [
    ViewEmailsComponent
  ],
  imports: [
    CommonModule,
    MaterialModule
  ]
})
export class ViewEmailsModule { }
